<template>
  <div id="menu">
    <SubHeader/>
    <div id="sm-menu">
      <img v-on:click="closeMenu()" src="../assets/close.png" id="close" alt="オンライン専門ZOOMコンパニオン「ズムコン！」">
      <ul>
        <a href="/"><li class="hover">トップページ</li></a>
        <a href="/menu"><li class="hover">料金システム</li></a>
        <a href="/companion"><li class="hover">コンパニオン</li></a>
        <a href="/service"><li class="hover">サービス紹介</li></a>
        <a href="/contact"><li class="hover">お問い合わせ</li></a>
      </ul>
    </div>
    <div class="top">
    <p class="subTitle-row">料金システム</p>
    </div>
    <div class="card-contents">
      <div class="flexbox">
  <section class="main">
    <p class="title">マンツーマン <br class="sp-br">-1対1で会話を楽しみたい-</p>
    <table border="3" style="border-collapse: collapse">
    <tr>
      <th class="table-title">プラン</th>
      <th class="table-value">概要</th>
      <th class="table-value">サービス提供価格</th>
    </tr>
    <tr>
      <td class="table-title">お試しプラン</td>
      <td>10分</td>
      <td>¥ 1,000</td>
    </tr>
    <tr>
      <td class="table-title">お食事お相手プラン</td>
      <td>30分</td>
      <td>¥ 2,500</td>
    </tr>
    <tr>
      <td class="table-title">1時間プラン</td>
      <td>60分</td>
      <td>¥ 4,000</td>
    </tr>
    <tr>
      <td class="table-title">延⻑料金</td>
      <td>30分</td>
      <td>¥ 1,500</td>
    </tr>
    <tr>
      <td class="table-title">がんばれドリンク</td>
      <td>1杯</td>
      <td>¥ 1,000</td>
    </tr>
    <tr>
      <td class="table-title">指名料</td>
      <td></td>
      <td>¥ 1,000</td>
    </tr>
    <tr>
      <td colspan="3">🔰マークの子は全て半額です。</td>
    </tr>
  </table>
  </section>
  <section class="side">
    <img src="../assets/companion.jpeg" alt="ズームコンパ">
  </section>
</div>
    </div>
    <div class="card-contents" id="multiple">
      <div class="flexbox">
  <section class="main">
    <p class="title">複数スタッフ <br class="sp-br">-みんなで楽しみたい-</p>
    <table border="3" style="border-collapse: collapse">
    <tr>
      <th class="table-title">プラン</th>
      <th class="table-value">概要</th>
      <th class="table-value">サービス提供価格</th>
    </tr>
    <tr>
      <td class="table-title">30分プラン</td>
      <td>30分</td>
      <td>¥ 2,000</td>
    </tr>
    <tr>
      <td class="table-title">1時間プラン</td>
      <td>60分</td>
      <td>¥ 3,500</td>
    </tr>
    <tr>
      <td class="table-title">延長料金</td>
      <td>30分</td>
      <td>¥ 1,500</td>
    </tr>
    <tr>
      <td colspan="3">🔰マークの子は全て半額です。</td>
    </tr>
  </table>
  </section>
  <section class="side">
    <img src="../assets/plan2.jpg" alt="ズームコンパ">
  </section>
    </div>
    </div>
     <!--
    <div class="card-contents">
      <div class="flexbox">
  <section class="main">
    <p class="title">マンツーマン お試しプラン</p>
    <p class="description">10分 ¥1000</p>
    <p class="description">延長 30分毎¥1500</p>
    <p class="description">がんばれドリンク ¥1000</p>
    <p class="description">指名料 ¥1000</p>
    <p class="description">🔰マークの子は全て半額です。</p>
    <p class="description">まずは<span>どんな風な雰囲気なのか知りたい方</span>にはこのプラン！！</p>
  </section>
  <section class="side">
    <img src="../assets/companion.jpeg" alt="ズームコンパ">
  </section>
</div>
    </div>
    <div class="card-contents">
      <div class="flexbox">
  <section class="main">
    <p class="title">マンツーマン お食事お相手プラン</p>
    <p class="description">30分 ¥2500</p>
    <p class="description">延長 30分毎¥1500</p>
    <p class="description">がんばれドリンク ¥1000</p>
    <p class="description">指名料 ¥1000</p>
    <p class="description">🔰マークの子は全て半額です。</p>
    <p class="description">コンパニオンと<br><span>一緒にお食事をして盛り上がりたい方</span>にはこのプラン！！</p>
  </section>
  <section class="side">
    <img src="../assets/plan2.jpg" alt="ズームコンパ">
  </section>
    </div>
    </div>
    <div class="card-contents">
      <div class="flexbox">
  <section class="main">
    <p class="title">マンツーマン 1時間プラン</p>
    <p class="description">60分 ¥4000</p>
    <p class="description">延長 30分毎¥1500</p>
    <p class="description">がんばれドリンク ¥1000</p>
    <p class="description">指名料 ¥1000</p>
    <p class="description">🔰マークの子は全て半額です。</p>
    <p class="description"><span>ガッつり楽しい時間を過ごしたい方</span>にはこのプラン！！</p>
  </section>
  <section class="side">
    <img src="../assets/plan3.jpg" alt="ズームコンパ">
  </section>
    </div>
    </div>
    <div class="card-contents">
      <div class="flexbox">
  <section class="main">
    <p class="title">複数ZOOM飲みプラン</p>
    <p class="description">30分 ¥2000</p>
    <p class="description">60分 ¥3500</p>
    <p class="description">延長 30分毎¥1500</p>
    <p class="description">がんばれドリンク ¥1000</p>
    <p class="description">指名料 ¥1000</p>
    <p class="description">🔰マークの子は全て半額です。</p>
    <p class="description">みんなで<span>ワイワイして盛り上がりたい方</span>にはこのプラン！！</p>
  </section>
  <section class="side">
    <img src="../assets/plan4.jpg" alt="ズームコンパ">
  </section>
    </div>
    </div>-->
     <div class="reserve-button-wrap">
    <a class="reserve-button" href="https://coubic.com/kei-corporation/943293#pageContent" target="_blank">予約はこちら</a>
    </div>
    <Footer/>
  </div>
</template>
<style scoped>
table{
  width: 90%;
  margin: 0 auto;
}
.sp-br{
  display: none;
}
.table-title{
  width: 50%;
  text-align: left;
}
.table-value{
  width: 25%;
}
.reserve-button{
background-color:#FFA07A;
  padding: 8px;
  width: 400px;
  font-size: 36px;
  border-radius: 30px;
  color: white!important;
}
.reserve-button-wrap{
  margin: 5%;
}
.reserve-button-wrap a{
  text-decoration: none;
  color: white;
}
.reserve-button-wrap a:hover{
  background-color:#FF8C00;
}
.subTitle-row{
  background-image: url(../assets/bg-title.jpg);
background-size:cover;
  height: 50px;
  line-height: 50px;
 color:white;
 box-shadow: 4px 4px #005FFF;
  width: 70%;
  margin:36px auto;
  font-size:24px;
  border-radius: 5px 5px 5px 5px;
  font-weight: bold;
  border: 5px solid  white;
}
.card-contents{
   background-color: white;
   box-shadow: 4px 4px #006600;
  width: 70%;
  margin: 36px auto;
  text-align: center;
}
.card-contents:hover {
  transform: translateY(-0.1875em);
}
.card-contents .title{
  text-align: left;
  color: #333333;
  font-size:24px;
  padding-left: 36px;
  font-weight: bold;
}
.main {
  margin-bottom: 10px;
  width: 70%;
}
.side {
  width: 30%;
}
.side img{
  width: 100%;
  border-radius: 10px 10px 10px 10px;
}
.card-contents .description{
  text-align: left;
  font-size:18px;
  color: #333333;
  font-weight: bold;
  padding-left: 36px;
}
.main,
.side {
  border-radius: 10px
}
.side {
  padding-top: 10%;
  padding-bottom: 10%;
  padding-left:5%;
  padding-right: 5%;
}
#multiple .side {
  padding-top: 5%;
  padding-bottom: 5%;
  padding-left:5%;
  padding-right: 5%;
}
.top{
  padding-top: 0px;
}
span{
  background:rgba(0, 0, 0, 0) linear-gradient(transparent 90%, rgba(255,215,0,0.9) 0%) repeat scroll 0 0;
}

/* Responsive */
@media ( min-width : 600px ){
    .flexbox {
      display: -webkit-flex;
      display: flex;
    }
  .main {
    margin: 0 10px 0 0;
  }
}

#sm-menu{
  background-color:rgba(0,0,0,0.9);
  display: none;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: black;
  position: fixed;
}
#close{
display: block;
position: absolute;
width: 64px;
height:64px;
top:16px;
right:16px;
}
@media ( max-width : 680px ){
  .subTitle-row{
  width: 90%;
}
  .card-contents{
  width: 90%;
  padding-top: 16px;
  padding-bottom: 36px;
}
.main {
  width: 100%;

}
.side {
  width: 100%;
}
.card-contents .title{
  text-align: center;
  padding-left: 0px;
  color: #333333;
  font-size:24px;
  font-weight: bold;
}
.card-contents .description{
  text-align: center;
  padding-left: 0px;
  width: 300px;
  font-weight: bold;
  margin:16px auto;
}
 a{
    color: #555555!important;
   font-weight: bold;
  text-decoration: none;
  font-size:24px;
}
  #sm-menu li{
    display: block;
   background-image: url(../assets/bg-body.jpg);
    color: #555555!important;
     margin-left: 16px;
     margin-right: 16px;
    margin-top: 16px;
     margin-bottom: 16px;
     font-size:24px;
     line-height: 70px;
  border-radius: 10px 10px 10px 10px;
  height: 70px;
  }
  #sm-menu  li a{
   color: white;
  text-decoration: none;
  font-size:24px;
  line-height:70px;
}
  #sm-menu ul{
    margin-top: 100px;
     color: #555555!important;
     padding:inherit;

  }
  .subTitle-row{
    width: 90%;
  }
  #companion .item {
  border-radius: 10px;
  background-color: white;
  background-color:rgba(255,54,127,0.7);
  margin: 0 auto;
  width: 30%;
  text-align: center;
}
#companion .flexbox {
    display: flex;
    flex-wrap: wrap;
    width: 90%;
    margin-left: 5%;
    justify-content: center;
    }
     .subTitle-row{
  margin:0px auto;
}
.side {
  padding-left:initial!important;
}
#multiple .side {
  padding-top: 5%;
  padding-bottom: 0%;
  padding-left:0%;
  padding-right: 5%;
}
.sp-br{
  display: block;
}

.side img{
  width: 90%;
}
.top{
  padding-top: 100px;
}

}
</style>
<script>
import SubHeader from './common/SubHeader'
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    SubHeader, Footer
  },
  methods: {
    closeMenu: function () {
      document.getElementById('sm-menu').style.display = 'none'
      document.getElementById('sm-menu-icon').style.display = 'block'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue